import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IPageableResponse} from '../../../../global/pagging.dto';
import {Organization, Orgfield, RecipientRole} from '../../edit-template/edit-template.dto';

@Injectable({
    providedIn: 'root'
})

export class RecipientfieldsService {
    constructor(private http: HttpClient) {
        
    }

    /**
     * fetch recipient roles and fields
     */
    fetchRecipientFields() {
        return this.http.get<RecipientRole[]>(`recipientroles`);
    }

    /**
    * add new role    
    */
    addNewRole(form: { role_name: string, role_color:string, personfields?: RecipientRole[], orgfields?: Orgfield[] }) {
        return this.http.post(`recipientroles`, form);
    }

    /**
    * update role    
    */
    updateRole(form: { id:number }) {
        console.log(form, 'form')
        return this.http.put(`recipientroles/${form?.id}`, form);
    }

    /**
    * Delete role    
    */
    deleteRole(id: number) {
        return this.http.delete(`recipientroles/${id}`);
    }

    /**
     * search recipient for role
     * @param query 
     */
    searchRecipient(query: string) {
        return this.http.get<IPageableResponse<RecipientRole>>('recipientroles/recipientsearch?q=' + query);
    }

    /**
     * search organization for role
     * @param page
     * @param query 
     */
    searchOrganization(page:number=0,query:string=''){
        return this.http.get<IPageableResponse<Organization>>(`recipientroles/organizationsearch?page=${page}&q=${query}`);
    }
}
